import React from 'react';
import { deleteItem } from '../api/reservationsApi';

function Line({ label, value, bold }) {
  return (
    <div className="flex justify-between text-sm">
      <div className="text-gray-600">{label}</div>
      <div className={bold ? 'font-semibold' : ''}>{value}</div>
    </div>
  );
}

export default function CartSummary({ cart, items = [], quote, onRefresh, onCheckout }) {

  const fmtISO = (iso) => (iso ? String(iso).slice(0,16).replace('T',' ') : '');
  const schedule = Array.isArray(quote?.pay_later_schedule) ? quote.pay_later_schedule : [];

  async function remove(it) {
    await deleteItem(cart.id, it.id);
    await onRefresh();
  }

  return (
    <div className="border rounded-2xl p-4 bg-white shadow-sm">
      <div className="font-semibold mb-2">Your selection</div>
      <div className="space-y-2 max-h-72 overflow-auto">
        {items.map(it => {
          const when = (() => {
            if (it.offering_kind === 'ac_room_type') {
              const s = it.guests_json?.ac_start_date;
              const e = it.guests_json?.ac_end_date;
              if (s && e) return `${s} → ${e}`;
            }
            const local = it.guests_json?.slot_start_local;
            if (local) return local.replace('T', ' ');
            if (typeof it.slot_start === 'string' && it.slot_start.length >= 16) {
              return it.slot_start.slice(0, 16).replace('T', ' ');
            }
            return 'Open-dated';
          })();

          const partySize = Number(it.guests_json?.party_size || 1);

          return (
            <div key={it.id} className="text-sm border rounded p-2 flex justify-between items-start">
              <div>
                <div className="font-medium">{it.title || it.offering_kind}</div>
                <div className="text-xs text-gray-500">{when}</div>
                <div className="text-xs text-gray-500">Party: {partySize}</div>
              </div>
              <div className="text-right">
                <div>€{Number(it.base_price_preview).toFixed(2)}</div>
                <button onClick={() => remove(it)} className="text-xs text-red-600 hover:underline">Remove</button>
              </div>
            </div>
          );
        })}
        {!items.length && <div className="text-xs text-gray-500">No items yet.</div>}
      </div>

      <div className="my-3 border-t pt-3 space-y-1">
        <Line label="Subtotal" value={`€${Number(quote.subtotal || 0).toFixed(2)}`} />

        {/* Pay-now line (if any) */}
        <Line label="Pay now" value={`€${Number(quote.pay_now || 0).toFixed(2)}`} />

        {/* Future charges */}
        {schedule.length === 1 && (
          <Line
            label={`Pay on ${fmtISO(schedule[0].at)}`}
            value={`€${Number(schedule[0].amount || 0).toFixed(2)}`}
          />
        )}
        {schedule.length > 1 && (
          <>
            <div className="text-xs text-gray-600 mt-1">Pay on</div>
            <div className="space-y-1">
              {schedule.map((r, i) => (
                <Line key={i} label={fmtISO(r.at)} value={`€${Number(r.amount || 0).toFixed(2)}`} />
              ))}
            </div>
          </>
        )}

        <Line label="Hold (Cancellation/No show Fee)" value={`€${Number(quote.hold_amount || 0).toFixed(2)}`} />
      </div>

      <button
        disabled={!items.length}
        onClick={onCheckout}
        className="w-full py-2 rounded bg-black text-white disabled:opacity-40">
        Checkout
      </button>
      <div className="text-[11px] text-gray-500 mt-2">
        By continuing you agree to the business’ fee and cancellation policies.
      </div>
    </div>
  );
}
